interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: "sm" | "md" | "lg";
  onClick?: () => void;
}

export default function Card({ children, className = "", padding = "lg", onClick }: CardProps) {
  const paddings = {
    sm: "p-4",
    md: "p-5",
    lg: "p-6",
  };

  return (
    <div
      className={`card ${paddings[padding]} ${onClick ? "cursor-pointer hover:bg-surface-hover transition-colors" : ""} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
}